/**
 * @todo Удалить файл с экспериментом
 * @description Данный функционал появился в задаче CD-199718, будет удалён в задаче CD-199865
 * Если группа А победит, то оставить файл, но переименовать его в TgbNativedescGeneral
 * Если победит группа В, то по удалить файл
 */

import { Label, Avatar, UIHeading3, IconChevronRight16, UIHeading5 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './TgbNativedescGeneralA.css';
import { Ticker } from '../../helpers/Ticker/Ticker';

export type TgbNativedescGeneralProps = {
  url: string;
  image: string;
  logoUrl: string | undefined;
  title: string;
  annotation: string;
  label: string | undefined;
  description: string | undefined;
};

export const TgbNativedescGeneral: React.FC<TgbNativedescGeneralProps> = props => {
  const { title, annotation, image, url, label, logoUrl, description } = props;

  return (
    <a href={url} target="_blank" className={styles['container']} rel="noopener noreferrer">
      <div className={styles['photo-block']} style={{ backgroundImage: `url(${image})` }}>
        {!!label && (
          <div className={styles['photo-label']}>
            <Label color="white_100" background="black_60">
              {label}
            </Label>
          </div>
        )}
        {!!logoUrl && (
          <div className={styles['avatar']}>
            <Avatar size={70} src={logoUrl} type="builder" />
          </div>
        )}
        {!!annotation && (
          <div className={styles['annotation']}>
            <Ticker text={annotation} />
          </div>
        )}
      </div>
      <div className={styles['content']}>
        <div className={styles['title-container']}>
          <UIHeading3>{description}</UIHeading3>
          <div className={styles['button-icon-wrapper']}>
            <IconChevronRight16 color="primary_100" />
          </div>
        </div>

        <UIHeading5 color="primary_100">{title}</UIHeading5>
      </div>
    </a>
  );
};
